import React from 'react';
import { RiHeartFill, RiMoneyDollarCircleLine } from "react-icons/ri";

function Progress(props) {
    return (
        <div className="progress">
            <div className="progress-score" style={{color: 'red'}}>
            <RiHeartFill size="30"/>
            <span>{props.health}</span>
            </div>
            <span>Day {props.current} of {props.total}</span>
            <div className="progress-score" style={{color: 'green'}}>
            <RiMoneyDollarCircleLine size="30"/>
            <span>{props.score}</span>
            </div>
        </div>
        
    );
}

export default Progress;
